document.addEventListener('DOMContentLoaded', function () {
    if (cobrandOverrides.length === 0) {
        return;
    }

    function updateLink(link, cobrandOverride) {
        if (link) {
            link.href = cobrandOverride.url;
            if (cobrandOverride.text.length > 0) {
                link.innerHTML = cobrandOverride.text;
            }

            //if link is outside of greenpath.com, we need to open in new window.
            if (link && !link.href.startsWith(gpf_home)) {
                link.target = '_blank';
            }
        }
    }

    cobrandOverrides.forEach(function (cobrandOverride) {
        //target navigation elements
        let navItems = document.body.querySelectorAll('.wp-block-navigation-link.' + cobrandOverride.class + ' a');
        if (navItems.length) {
            [].forEach.call(navItems, function (link) {
                updateLink(link, cobrandOverride);
            }, cobrandOverride);
        }


        //target .wp-block-buttons with specified class + a
        let buttons = document.body.querySelectorAll('.wp-block-button.' + cobrandOverride.class + ' a');
        if (buttons.length) {
            [].forEach.call(buttons, function (link) {
                updateLink(link, cobrandOverride);
            }, cobrandOverride);
        }

        //target paragraphs with specified class + a (typical for text)
        let paragraphs = document.body.querySelectorAll('p.' + cobrandOverride.class + ' a');
        if (paragraphs.length) {
            [].forEach.call(paragraphs, function (link) {
                updateLink(link, cobrandOverride);
            }, cobrandOverride);
        }

        //target a
        let links = document.body.querySelectorAll('a.' + cobrandOverride.class);
        if (links.length) {
            [].forEach.call(links, function (link) {
                updateLink(link, cobrandOverride);
            }, cobrandOverride);
        }
    });
});